import { render, staticRenderFns } from "./schoollist.vue?vue&type=template&id=07ad2646&scoped=true&"
import script from "./schoollist.vue?vue&type=script&lang=js&"
export * from "./schoollist.vue?vue&type=script&lang=js&"
import style0 from "./schoollist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./schoollist.vue?vue&type=style&index=1&id=07ad2646&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ad2646",
  null
  
)

export default component.exports